import styles from 'views/student/library-view/subviews/home-view.module.css';

export const EarnSRP = () => (
  <div className={styles.StatName}>Earn SRP to join the leaderboard</div>
);
